<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>{{ review.reviewer }} reviews 
            <router-link :to="{name: 'play', params: {slug: review.playslug}}">
              {{ review.playtitle }}
            </router-link>
            </h1>
        </div>
    </section>
  </div>

  <section class="section">
    <div class="container">

      <div class="columns top-section">
        <div class="column is-two-thirds">

          <section class="block formatted-text">
            <div class="content">
              <p v-html="review.text" />
            </div>
            <div class="has-text-right">&mdash; {{ review.reviewer }}</div>
          </section>
        </div>

      </div>

    </div>
  </section>

</div>
</template>

<script>
//import ProductShopRows from './productShopEventRows/ProductShopRows';
import Api from '@/config/Api'
//import mixins from '@/mixins/mixins'

import { mapGetters, mapState } from 'vuex'

export default {
  props: ['slug','reviewindex'],
  //mixins: [mixins],
  components: {
    /*ProductShopRows,
    ProductEventRows,
    AlertMeButton,
    MaxPriceWidget*/
  },
  data(){
    return {
      review: { playslug: "/" }
    }
  },
  /* computed: {
  }, */
  created() { 
    Api().get(`/api/plays/${this.slug}/reviews/${this.reviewindex}`).then(response => {
      this.review = response.data;

      //this.$set(this.product, 'rrpPrice', 2);
      this.$store.commit('setContentLoaded', true); // then footer will be displayed
    })
    .catch((err) => {
      console.log("this.slug",this.slug);
      this.$router.push({ name: 'play', params: {slug: this.slug} });
    });
  },
  /*
  methods: {
  } */
  
}
</script>

<style>
.section-title {
  text-align: center;
}
.hidden {
  display: none;
}
.visible {
  display: block;
}
.realtime-message-container {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 1rem;
}
.spinner {
  display: inline-block;
}
.realtime-message1 {
}
.realtime-message2 {
  display: block;
  /* line-height: 1.8em; */
  white-space: normal;
}
#ball-spinner {
  position: relative;
  right: .2em;
  top: .3em;
}
.toggleButton {
  text-align: center;
  margin: 1.5rem;
}

.venuesDatesPrices {
  background: lightgrey;
}

.venuesDatesPrices .title3 {
  margin-top: 0.4rem;
}
.venuesDatesPrices .text-small {
  margin: 0.4rem 0 0.4rem 0;
}

table.table-productionteamcastlist {
  margin: 0 auto;
  margin-bottom: 4em !important;
  table-layout: fixed;
  width: 100%;
  font-size: 0.95rem;
}
table.table-productionteamcastlist td {
  width: 100%;
  padding: 0 10px;
  word-wrap: break-word;
}

.video {
    position: relative;
    display: inline-block;
}
.video:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: transparent url(/images/icons/youtube-play-button.png) center center no-repeat;
}

.reviewer {
  margin-top: 0.7em;
  font-size: 0.8rem;
}

.vertical-card-gap {
  margin-bottom: 1.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Review.vue